import {
  PDP_BILLING,
  PDP_CHECKOUT_PROGRESS,
  PDP_DELIVERY,
  PDP_DIFF_ADDR,
  PDP_ORDER_PREVIEW,
  PDP_SUMMARY,
  PDP_SHIPPING,
  PDP_PERSONAL_INFO,
  PDP_TOUCH_POINT,
  PDP_BUNDLE,
  PDP_LCC,
  PDP_PLANTYPE,
  PDP_LOAN_LEADS_DATA,
  PDP_LOAN_ORDER_STATUS,
  CLEAR_PDP_BUNDLE,
  CLEAR_PDP_LCC,
  CLEAR_PDP_PLANTYPE,
  CLEAR_PDP_SUMMARY,
  CLEAR_PDP_LOAN_LEADS_DATA,
  PDP_STOCK,
  CLEAR_PDP,
  PDP_MARKET,
  PDP_RISK_CHECK
} from "../actions";
import { S_PDP_BILLING, S_PDP_PERSONAL_INFO, S_PDP_DELIVERY, S_PDP_SUMMARY, S_PDP_LOAN_LEADS_DATA, S_PDP_SHIPPING, webStorage, S_PDP_TOUCH_POINT, S_PDP_BUNDLE, S_PDP_LCC, S_PDP_PLAN_TYPE, S_PDP_MARKET, S_PDP_LOAN_ORDER_STATUS, S_PDP_RISK_CHECK } from "../../utils/webStorage";
import { isBizNull } from "../../utils";
import { restoreData } from "../restoreData";
const pdpSummary = restoreData(S_PDP_SUMMARY, {});
const pdpLoanLeadsData = restoreData(S_PDP_LOAN_LEADS_DATA);
const pdpShipping = restoreData(S_PDP_SHIPPING);
const pdpPersonalInfo = restoreData(S_PDP_PERSONAL_INFO);
const pdpBilling = restoreData(S_PDP_BILLING);
const pdpTouchPoint = restoreData(S_PDP_TOUCH_POINT);
const pdpDelivery = restoreData(S_PDP_DELIVERY);
const pdpBundle = restoreData(S_PDP_BUNDLE);
const pdpLcc = restoreData(S_PDP_LCC);
const pdpPlanType = restoreData(S_PDP_PLAN_TYPE);
const pdpMarket = restoreData(S_PDP_MARKET);
const pdpLoanOrderStatus = restoreData(S_PDP_LOAN_ORDER_STATUS);
const pdpRiskCheck = restoreData(S_PDP_RISK_CHECK);
export const initialPdpState = {
  pdpCheckoutProgress: {
    steps: []
  },
  pdpDiffAddr: false,
  pdpSummary,
  pdpShipping,
  pdpPersonalInfo,
  pdpBilling,
  pdpTouchPoint,
  pdpDelivery,
  pdpBundle,
  pdpLcc,
  pdpPlanType,
  pdpStock: null,
  pdpLoanLeadsData,
  pdpLoanOrderStatus,
  pdpMarket,
  pdpRiskCheck
};
export function pdpReducers(state, action) {
  const { type, payload } = action;
  switch (type) {
    case PDP_MARKET:
      webStorage.set(S_PDP_MARKET, payload);
      return {
        ...state,
        pdpMarket: payload
      };
    case PDP_CHECKOUT_PROGRESS:
      return {
        ...state,
        pdpCheckoutProgress: {
          steps: payload.steps
        }
      };
    case PDP_DIFF_ADDR:
      return {
        ...state,
        pdpDiffAddr: payload
      };
    case PDP_DELIVERY:
      if (isBizNull(payload)) {
        webStorage.clear(S_PDP_DELIVERY);
      } else {
        webStorage.set(S_PDP_DELIVERY, payload);
      }
      return {
        ...state,
        pdpDelivery: payload
      };
    case PDP_ORDER_PREVIEW:
      return {
        ...state,
        pdpOrderPreview: payload
      };
    case PDP_SUMMARY:
      webStorage.set(S_PDP_SUMMARY, payload);
      return {
        ...state,
        pdpSummary: payload
      };
    case PDP_LOAN_LEADS_DATA:
      webStorage.set(S_PDP_LOAN_LEADS_DATA, payload);
      return {
        ...state,
        pdpLoanLeadsData: payload
      };
    case PDP_SHIPPING:
      if (isBizNull(payload)) {
        webStorage.clear(S_PDP_SHIPPING);
      } else {
        webStorage.set(S_PDP_SHIPPING, payload);
      }
      return {
        ...state,
        pdpShipping: payload
      };
    case PDP_PERSONAL_INFO: {
      if (isBizNull(payload)) {
        webStorage.clear(S_PDP_PERSONAL_INFO);
      } else {
        webStorage.set(S_PDP_PERSONAL_INFO, payload);
      }
      return {
        ...state,
        pdpPersonalInfo: payload
      };
    }
    case PDP_BILLING:
      if (isBizNull(payload)) {
        webStorage.clear(S_PDP_BILLING);
      } else {
        webStorage.set(S_PDP_BILLING, payload);
      }
      return {
        ...state,
        pdpBilling: payload
      };
    case PDP_TOUCH_POINT:
      if (payload === null) {
        webStorage.clear(S_PDP_TOUCH_POINT);
      } else {
        webStorage.set(S_PDP_TOUCH_POINT, payload);
      }
      return {
        ...state,
        pdpTouchPoint: payload
      };
    case PDP_BUNDLE:
      webStorage.set(S_PDP_BUNDLE, payload);
      return {
        ...state,
        pdpBundle: payload
      };
    case PDP_LCC:
      webStorage.set(S_PDP_LCC, payload);
      return {
        ...state,
        pdpLcc: payload
      };
    case PDP_PLANTYPE:
      webStorage.set(S_PDP_PLAN_TYPE, payload);
      return {
        ...state,
        pdpPlanType: payload
      };
    case PDP_STOCK:
      return {
        ...state,
        pdpStock: payload
      };
    case PDP_LOAN_ORDER_STATUS:
      webStorage.set(S_PDP_LOAN_ORDER_STATUS, payload);
      return {
        ...state,
        pdpLoanOrderStatus: payload
      };
    case CLEAR_PDP_BUNDLE:
      webStorage.clear(S_PDP_BUNDLE);
      return {
        ...state,
        pdpBundle: null
      };
    case CLEAR_PDP_LCC:
      webStorage.clear(S_PDP_LCC);
      return {
        ...state,
        pdpLcc: null
      };
    case CLEAR_PDP_PLANTYPE:
      webStorage.clear(S_PDP_PLAN_TYPE);
      return {
        ...state,
        pdpPlanType: null
      };
    case CLEAR_PDP_SUMMARY:
      webStorage.clear(S_PDP_SUMMARY);
      return {
        ...state,
        pdpSummary: {}
      };
    case CLEAR_PDP_LOAN_LEADS_DATA:
      webStorage.clear(CLEAR_PDP_LOAN_LEADS_DATA);
      return {
        ...state,
        pdpLoanLeadsData: null
      };
    case PDP_RISK_CHECK:
      if (isBizNull(payload)) {
        webStorage.clear(S_PDP_RISK_CHECK);
      } else {
        webStorage.set(S_PDP_RISK_CHECK, payload);
      }
      return {
        ...state,
        pdpRiskCheck: payload
      };
    case CLEAR_PDP:
      webStorage.clear(S_PDP_MARKET);
      webStorage.clear(S_PDP_BILLING);
      webStorage.clear(S_PDP_PERSONAL_INFO);
      webStorage.clear(S_PDP_DELIVERY);
      webStorage.clear(S_PDP_SHIPPING);
      webStorage.clear(S_PDP_TOUCH_POINT);
      webStorage.clear(S_PDP_BUNDLE);
      webStorage.clear(S_PDP_LCC);
      webStorage.clear(S_PDP_SUMMARY);
      webStorage.clear(S_PDP_PLAN_TYPE);
      webStorage.clear(S_PDP_LOAN_LEADS_DATA);
      webStorage.clear(S_PDP_RISK_CHECK);
      return {
        ...state,
        pdpBilling: null,
        pdpPersonalInfo: null,
        pdpDelivery: null,
        pdpShipping: null,
        pdpBundle: null,
        pdpLcc: null,
        pdpPlanType: null,
        pdpSummary: {},
        pdpOrderPreview: null,
        pdpCheckoutProgress: {
          steps: []
        },
        pdpLoanLeadsData: null,
        pdpMarket: null,
        pdpRiskCheck: null
      };
    default:
      return {
        ...state
      };
  }
}
